import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment, Label } from "semantic-ui-react";

import { changePassword } from "../../actions/password/change";
import SystemHeader from "../../components/system_header";
import "../../App.css";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: this.props.match.params.token,
      new_password: "",
      confirm_password: "",
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
    };

    this.isFormSubmitted = false;
  }

  onChange = () => {
    this.isFormSubmitted = true;
    this.props.changePassword({
      password: this.state.new_password,
      password_confirmation: this.state.confirm_password,
      reset_password_token: this.state.token,
    });
  };

  composeErrorMessages = () => {
    const { change_error, too_short_password, unmatch_passwords, expired_reset_link } = this.state.translations;
    const messages = [];

    if (this.props.error === "Bad Request") {
      messages.push(change_error);
    } else {
      Object.keys(this.props.error).forEach((error_type) => {
        if (error_type === "password") {
          messages.push(too_short_password);
        } else if (error_type === "password_confirmation") {
          messages.push(unmatch_passwords);
        } else if (error_type === "reset_password_token") {
          messages.push(expired_reset_link);
        }
      });
    }

    return messages;
  };

  render() {
    const { change_instruction, new_password, confirm_password, change_password, change_success, login_button_text } = this.state.translations;
    const isSuccessShown = this.isFormSubmitted && !this.props.pending && !this.props.changeFailure;
    const isInvalidShown = this.isFormSubmitted && !this.props.pending && this.props.changeFailure;
    const isFormShown = this.isFormSubmitted ? !isSuccessShown : true;
    const errorMessages = isInvalidShown ? this.composeErrorMessages() : [];

    return (
      <div>
        <SystemHeader showLanguage={false} />
        <div className="change-password-form">
          <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              {isFormShown && (
                <div>
                  <Header as="h2" color="teal" textAlign="center">
                    {change_instruction}
                  </Header>
                  <Form size="large">
                    <Segment>
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder={new_password}
                        type="password"
                        onChange={(event) => this.setState({ new_password: event.target.value })}
                        value={this.state.new_password}
                      />
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder={confirm_password}
                        type="password"
                        onChange={(event) => this.setState({ confirm_password: event.target.value })}
                        value={this.state.confirm_password}
                      />
                      <Button loading={this.props.pending} color="teal" fluid size="large" onClick={this.onChange} disabled={this.props.pending}>
                        {change_password}
                      </Button>
                    </Segment>
                  </Form>
                </div>
              )}
              {isSuccessShown && (
                <Header as="h4" color="teal" textAlign="center">
                  <p>{change_success}</p>
                  <Button color="teal" href="/">
                    {login_button_text}
                  </Button>
                </Header>
              )}
              {isInvalidShown && (
                <div>
                  <br />
                  <Label className="credentials-error" style={{ marginTop: "20px" }}>
                    {errorMessages.map((item, i) => (
                      <p key={i}> {item}</p>
                    ))}
                  </Label>
                </div>
              )}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pending: state.change_password.pending,
    changeFailure: state.change_password.changeFailure,
    error: state.change_password.error,
    language: state.language.language,
    languages: state.language.languages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (details) => {
      dispatch(changePassword(details));
    },
  };
};

let ChangePasswordPage = connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
export default ChangePasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/change.js